import { formatTime } from "../utils/video-duration.js";
import { initVideoDuration } from "../modules/video-duration.js";

export function initVideoPlayer() {
	const container = document.querySelector(".video-container");

	const containerVideoChildren = document.querySelectorAll(".video-children");

	if (!container) return;

	const mainVideo = container.querySelector(".video-element");

	const playPauseBtn = container.querySelector(".btn-play-pause");

	const progressBar = container.querySelector(".progress-bar");

	const volumnBtn = container.querySelector(".btn-volume");

	const fullScreenBtn = container.querySelector(".btn-fullscreen");

	const videoTimeline = container.querySelector(".progress-container");

	const currentVideoTime = container.querySelector(".time-video");


	// handle progress bar

	const draggableProgressBar = (e) => {
		let timelineWidth = videoTimeline.clientWidth;
		progressBar.style.width = `${e.offsetX}px`;
		mainVideo.currentTime = (e.offsetX / timelineWidth) * mainVideo.duration;
		currentVideoTime.innerText = formatTime(mainVideo.currentTime);
	};

	const draggableProgressBarTouch = (e) => {
		const progressTime = videoTimeline.querySelector("span");

		const rect = videoTimeline.getBoundingClientRect();
		let offsetX = e.touches[0].clientX - rect.left;

		offsetX = Math.max(0, Math.min(offsetX, rect.width));

		progressTime.style.left = `${offsetX}px`;

		const percent = (offsetX / rect.width) * mainVideo.duration;
		progressTime.innerHTML = formatTime(percent);

		mainVideo.currentTime = percent;
	};
	// update time video

	mainVideo.addEventListener("timeupdate", (e) => {
		let { currentTime, duration } = e.target;
		let percent = (currentTime / duration) * 100;
		progressBar.style.width = `${percent}%`;
		currentVideoTime.innerText = formatTime(currentTime);
	});

	// event mouse

	videoTimeline.addEventListener("mousedown", () => {
		videoTimeline.addEventListener("mousemove", draggableProgressBar);
	});

	videoTimeline.addEventListener("mousemove", (e) => {
		const progressTime = videoTimeline.querySelector("span");
		let offsetX = e.offsetX;
		progressTime.style.left = `${offsetX}px`;
		let timelineWidth = videoTimeline.clientWidth;
		let percent = (e.offsetX / timelineWidth) * mainVideo.duration;
		progressTime.innerHTML = formatTime(percent);
	});

	container.addEventListener("mouseup", () => {
		videoTimeline.removeEventListener("mousemove", draggableProgressBar);
	});

	// event mobile

	videoTimeline.addEventListener("touchstart", () => {
		videoTimeline.addEventListener("touchmove", draggableProgressBarTouch);
	});

	videoTimeline.addEventListener("touchmove", (e) => {
		const progressTime = videoTimeline.querySelector("span");

		const rect = videoTimeline.getBoundingClientRect();
		let offsetX = e.touches[0].clientX - rect.left;

		offsetX = Math.max(0, Math.min(offsetX, rect.width));
		progressTime.style.left = `${offsetX}px`;

		let percent = (offsetX / rect.width) * mainVideo.duration;
		progressTime.innerHTML = formatTime(percent);
	});

	container.addEventListener("touchend", () => {
		videoTimeline.removeEventListener("touchmove", draggableProgressBarTouch);
	});

	// load data
	initVideoDuration({
		container: container,
		videoSelector: '.video-element',
		durationSelector: '.video-duration'
	});

	// click

	videoTimeline.addEventListener("click", (e) => {
		let timelineWidth = videoTimeline.clientWidth;
		mainVideo.currentTime = (e.offsetX / timelineWidth) * mainVideo.duration;
	});

	volumnBtn.addEventListener("click", () => {
		mainVideo.muted = !mainVideo.muted;

		if (mainVideo.muted) {
			volumnBtn.classList.replace("fi-rr-volume", "fi-rr-cross-circle");
		} else {
			mainVideo.volume = 1;
			volumnBtn.classList.replace("fi-rr-cross-circle", "fi-rr-volume");
		}
	});

	fullScreenBtn.addEventListener("click", () => {
		container.classList.toggle("fullscreen");
		if (document.fullscreenElement) {
			fullScreenBtn.classList.replace("fi-sr-compress", "fi-rr-expand");
			return document.exitFullscreen();
		}
		fullScreenBtn.classList.replace("fi-rr-expand", "fi-sr-compress");
		container.requestFullscreen();
	});

	playPauseBtn.addEventListener("click", () => {
		mainVideo.paused ? mainVideo.play() : mainVideo.pause();
	});

	mainVideo.addEventListener("play", () => {
		playPauseBtn.classList.replace("fi-sr-play", "fi-rr-pause");
	});
	mainVideo.addEventListener("pause", () => {
		playPauseBtn.classList.replace("fi-rr-pause", "fi-sr-play");
	});

	// children video

	if (containerVideoChildren.length === 0) return;

	containerVideoChildren.forEach((child) => {
		initVideoDuration({
			container: child,
			durationSelector: '.duration-children'
		});
	});
}
